<template>
  <div class="situationdisplay">
    <van-image v-for="image in images" :key="image.id" width="100%" fit="cover" :src="image.url"></van-image>
</div>
</template>

<script>

export default {
  name: 'situationdisplay',
  data() {
    return {
      images: [
        {
          id: 0,
          url: require('@/assets/m-img-3.png')
        },
        {
          id: 1,
          url: require('@/assets/m-img-4.png')
        },
        // {
        //   id: 2,
        //   url: require('@/assets/m-img-5.png')
        // },
        // {
        //   id: 3,
        //   url: require('@/assets/m-img-6.png')
        // },
        {
          id: 4,
          url: require('@/assets/m-img-7.png')
        },
        {
          id: 5,
          url: require('@/assets/m-img-8.png')
        },
        {
          id: 6,
          url: require('@/assets/m-img-9.png')
        }
      ]
    }
  }

}
</script>

<style scoped>
/* *{
  margin: 0;
  padding: 0;
} */
.situationdisplay {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}
</style>
